<template>
    <span
        class="VSearch"
        v-click-outside="hideInput"
    >
         <span
             @click="showInput"
             v-if="!isSearchActive"
             :class="localValue.length ? 'VInput-search_active':''"
         >
<!--             <img-->
<!--             src="/icons/components/VFeatureBlock/icon_search.svg"-->
<!--             alt="Settings"-->
<!--         >-->
         </span>
         <VInput
             v-if="isSearchActive"
             v-model="localValue"
             :placeholder="placeholder"
             @enter="enter"
             class="VInput_hidden"
             ref="vinput"
         >

         </VInput>
    </span>
</template>

<script>
    export default {
        name: 'VSearch',
        props: {
            type: {
                type: String,
                default: 'text',
            },
            value: {
                type: String,
                required: true,
            },
            placeholder: {
                type: String,
                required: false,
                default: 'Type something...',
            },
        },
        data() {
            return {
                localValue: '',
                isSearchActive: false,
            };
        },
        methods: {
            showInput() {
                this.isSearchActive = true;
                this.$nextTick(()=>{
                    this.$refs.vinput.$refs.input.focus();
                    const el =this.$refs.vinput.$el;
                    el.classList.add("VInput_showed");
                })
            },
            hideInput() {
                if (!this.localValue.length) {
                    this.isSearchActive = false;
                }
            },
            enter() {
                this.$emit('enter');
            },
        },
        watch: {
            value: {
                handler(newVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(this.localValue)) {
                        this.localValue = newVal;
                    }
                },
            },
            localValue: {
                handler(newVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(this.value)) {
                        this.$emit('input', newVal);
                    }
                },
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .VSearch {
        ::v-deep {
            .VInput {
                input {
                    transition: width $transition-speed $transition-function;
                    border-radius: 4px;
                }
                
            }
            
            .VInput_hidden {
                input {
                    width: 0;
                    padding: 0;
                    border: 0;
                }
            }
            .VInput_showed {
                input {
                    width: 120px;
                }
        
            }
    
        }
        
        &-icon {
            width: 19px;
            height: 18px;
            background-position: 0 0;
            background-repeat: no-repeat;
            background-image: url('data:image/svg+xml;base64,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');
        }
    }

</style>
